export default __webpack_public_path__ + "static/needlefilewithoutdust-5090317e2a6501c8cf337748e01ac75c.png";